/**
 * Returns true if a protocol is exotic, i.e., not http, https, mailto, sms,
 * tel, javascript, etc.
 *
 * Exotic protocols should not be shown to clients accessing the app inside
 * any of the web interfaces.
 */
export function hasExoticProtocol(url: string | URL) {
  const protocol = getProtocol(url);

  return !protocol.match(/^(https?|mailto|sms|tel|javascript):?$/);
}

export function hasJavascriptProtocol(url: string | URL) {
  const protocol = getProtocol(url);

  return protocol === "javascript:";
}

function getProtocol(url: string | URL) {
  return url instanceof URL ? url.protocol : new URL(url).protocol;
}
